import type { UseFormReturn } from "react-hook-form";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";

export const useReminderTemplateSelection = (
	form: UseFormReturn<ReminderFormModel>,
	templates: ReminderTemplate[],
) => {
	const { t } = useResource();
	const { setValue } = form;

	const selectTemplate = (template: ReminderTemplate) => {
		const name =
			template.isCustom || !template.labelKey ? "" : t(template.labelKey);
		setValue("name", name, {
			shouldValidate: true,
			shouldDirty: true,
		});
		setValue("recurrence", template.recurrence, {
			shouldValidate: true,
			shouldDirty: true,
		});
		setValue("typeKey", template.typeKey, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	const markAsCustom = () => {
		const customTypeKey = templates.find(
			(template) => template.isCustom,
		)?.typeKey;

		if (customTypeKey === undefined) {
			return;
		}

		setValue("typeKey", customTypeKey, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	return { selectTemplate, markAsCustom };
};
